import { incotermNames } from '../constants/strings';

const createConfig = configs => {
  const convertedConfigs = [];
  Object.values(configs).forEach(value => {
    convertedConfigs.push({ config_id: value });
  });
  return convertedConfigs;
};

const createConfigArray = configs => {
  const convertedConfigs = [];
  Object.values(configs).forEach(value => {
    convertedConfigs.push(value);
  });
  return convertedConfigs;
};

const patchValueToFormsInCustomerOnBoarding = (form, formName, formData, pswd = null) => {
  const formConfigs = {
    default: () => ``,
    default_unitofmeasurement: () => form.patchValue(formData),
    default_currency: () => form.patchValue(formData),
    mother_shipperdetails: () => form.patchValue(formData),
    default_countryofmanufacture: () => form.patchValue(formData),
    default_weight: () => form.patchValue(formData),
    mother_accountnumbers: () => {
      const accoundata: any = {};
      accoundata.shipperAccountNumber = formData.find(
        obj => obj.name === 'shipperAccountNumber'
      ).number;
      accoundata.payerAccountNumber = formData.find(
        obj => obj.name === 'payerAccountNumber'
      ).number;
      if (formData.length > 2) {
        const dutyAccountNumberObj = formData.find(obj => obj.name === 'dutyAccountNumber');

        if (dutyAccountNumberObj) {
          accoundata.dutyAccountNumber = dutyAccountNumberObj?.number;
        }
      }
      // formData.length > 2 &&
      //   (accoundata.dutyAccountNumber = formData.find(
      //     obj => obj.name == 'dutyAccountNumber'
      //   ).number);
      form.patchValue(accoundata);
    },

    baby_accountnumbers: () => {
      const accoundata: any = {};
      accoundata.shipperAccountNumber = formData.find(
        obj => obj.name === 'shipperAccountNumber'
      ).number;

      accoundata.payerAccountNumber = formData.find(
        obj => obj.name === 'payerAccountNumber'
      ).number;

      if (formData.length > 2) {
        const dutyAccountNumberObj = formData.find(obj => obj.name === 'dutyAccountNumber');

        if (dutyAccountNumberObj) {
          accoundata.dutyAccountNumber = dutyAccountNumberObj.number;
        }
      }
      // formData.length > 2 &&
      //   (accoundata.dutyAccountNumber = formData.find(obj => {
      //     return obj.name === 'dutyAccountNumber';
      //   }).number);
      form.patchValue(accoundata);
    },

    individualShip_accountnumbers: () => {
      const accoundata: any = {};
      accoundata.shipperAccountNumber = formData.find(
        obj => obj.name === 'shipperAccountNumber'
      ).number;

      accoundata.payerAccountNumber = formData.find(
        obj => obj.name === 'payerAccountNumber'
      ).number;

      if (formData.length > 2) {
        const dutyAccountNumberObj = formData.find(obj => obj.name === 'dutyAccountNumber');

        if (dutyAccountNumberObj) {
          accoundata.dutyAccountNumber = dutyAccountNumberObj.number;
        }
      }
      form.patchValue(accoundata);
    },

    mother_incoterm: () => {
      const placeofIncoterm = getPlaceofIncotermValue(formData.value);
      form.get('incoterm').setValue(formData.value);
      form.get('placeofIncoterm').setValue(placeofIncoterm);
    },

    default_incoterm: () => form.get('incoterm').setValue(formData.value),

    mother_exportdeclarationdetails: () => {
      form.get('description').setValue(formData.content.description);
      form.get('signatureName').setValue(formData.content.exportDeclaration.invoice.signatureName);
      form
        .get('signatureTitle')
        .setValue(formData.content.exportDeclaration.invoice.signatureTitle);
      form
        .get('signatureImage')
        .setValue(formData.content.exportDeclaration.invoice.signatureImage);
      form.get('exportReason').setValue(formData.content.exportDeclaration.exportReason);
      form.get('remark').setValue(formData.content.exportDeclaration.remarks[0].value);
    },

    individualShipment_exportdeclarationdetails: () => {
      form.get('description').setValue(formData.content.description);
      form.get('signatureName').setValue(formData.content.exportDeclaration.invoice.signatureName);
      form
        .get('signatureTitle')
        .setValue(formData.content.exportDeclaration.invoice.signatureTitle);
      form
        .get('signatureImage')
        .setValue(formData.content.exportDeclaration.invoice.signatureImage);
      form.get('exportReason').setValue(formData.content.exportDeclaration.exportReason);
      form.get('remark').setValue(formData.content.exportDeclaration.remarks[0].value);
      form
        .get('lineItemQuantityUnitofMeasurement')
        .setValue(formData.content.exportDeclaration.invoice.lineItemQuantityUnitofMeasurement);
      form
        .get('placeOfIncoterm')
        .setValue(formData.content.exportDeclaration.invoice.placeOfIncoterm);
      form.get('incoterm').setValue(formData.content.exportDeclaration.invoice.incoterm);
      form
        .get('invoiceUnitOfMeasurement')
        .setValue(formData.content.exportDeclaration.invoice.invoiceUnitOfMeasurement);
    },

    output_imageproperties: () => {
      form.get('printerDPI').setValue(formData.printerDPI);
      if (!formData.autoPrint || formData.autoPrint == '') {
        form.get('autoPrint').setValue('false');
      } else {
        form.get('autoPrint').setValue(formData.autoPrint);
      }
      form.get('encodingFormat').setValue(formData.encodingFormat);
      form.get('label').setValue(formData.imageOptions[0].templateName);
      form.get('waybillDoc').setValue(formData.imageOptions[1].templateName);
      form.get('invoiceType').setValue(formData.imageOptions[2].templateName);
      if (formData.imageOptions.length > 3) {
        form.get('print').setValue(formData.imageOptions[3].print);
      } else {
        form.get('print').setValue(true);
      }
    },
    prealert_reportparams: () => form.get('reportParams').setValue(formData.toString()),

    default_invoice_export: () => {
      form.get('exportInvoice').setValue(formData);
      sessionStorage.setItem('isCustomInvoice', formData.toString());
    },
    'paperless-trade': () => form.get('paperlessTrade').setValue(formData.paperlessTrade),
    customer_credential: () => {
      form.get('mydhlApiKey').setValue(formData.mydhlApiKey);
      form.get('postalLocationApiKey').setValue(formData.postalLocationApiKey);
      form.get('mydhlApiPassword').setValue(pswd);
    },
    unitPriceDecimalPoints: () => form.patchValue(formData),
    loose_bbx: () => {
      form.get('bbxType').setValue(formData);
      sessionStorage.setItem('loose-bbx', formData.toString());
    },
    label_print_config: () => form.patchValue(formData),
    baby_default_options: () => form.patchValue(formData),
    default_shipment_content: () => form.patchValue(formData),
    pickup_default_settings: () => form.patchValue(formData),
    report_configuration: () => {
      form.patchValue(formData);
    },
  };

  return (formConfigs[formName] || formConfigs.default)();
};

const basicSnackBarConfig = {
  addressComponentSave: {
    message: 'global.savedSuccess',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 4,
  },
  addressComponentUpdate: {
    message: 'global.updatedSuccess',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 4,
  },
  mappingShipmentSpecificationSave: {
    message: 'global.mappingSpecAdded',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 4,
  },
  shipmentListGenerateLabel: {
    message: 'global.generatingLabelWait',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 1000,
  },
  shipmentListViewLabel: {
    message: 'global.downloadingLabel',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 1000,
  },
  downloadLogs: {
    message: 'global.logsDownloaded',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 5,
  },
  pickupCancel: {
    message: 'global.pickupRequest',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 5,
  },
  remanifestSuccess: {
    message: 'global.babyManifestation',
    horizontalPosition: 'right',
    verticalPosition: 'top',
    duration: 5,
  },
};

const getPlaceofIncotermValue = (incoterm: string) => {
  return Object.keys(incotermNames).find(key => incotermNames[key].includes(incoterm));
};

export {
  createConfig,
  patchValueToFormsInCustomerOnBoarding,
  basicSnackBarConfig,
  getPlaceofIncotermValue,
  createConfigArray,
};
